import { Validators } from '@angular/forms';

import * as formUtils from '@shared/components/crud-form-base/crud-form-base.utils';

export enum NoPartyGroupEditMessage {
  MODAL_TITLE_CREATE = 'Create No Party Group',
  MODAL_TITLE_EDIT = 'Edit No Party Group',

  MODAL_HEADER = 'This group will be created in both Hall Pass and FlexTime modules',

  CHECKBOX_SECTION_LABEL = 'Make active for the following module(s):',
  CHECKBOX_SECTION_SECONDARY_LABEL = 'This group will be made active for each selected option',

  HALLPASS_CHECKBOX_LABEL = 'Hall Pass',
  FLEXTIME_CHECKBOX_LABEL = 'FlexTime',

  CANCEL_BUTTON_LABEL = 'Cancel',
  DELETE_BUTTON_LABEL = 'Delete',
  CLOSE_BUTTON_LABEL = 'Close',
  CREATE_BUTTON_LABEL = 'Create',
  SAVE_BUTTON_LABEL = 'Save',

  DELETE_CONFIRM_TITLE = 'Are you sure you want to delete this no party group?',
  DELETE_CONFIRM_MESSAGE = 'Deleting this group will remove it from both Hall Pass and FlexTime modules',

  RECORD_EDIT_FORM_ERROR = 'Please fix the errors in the form to continue',
}

// Need enum object to pull from keys of IMembershipList
export enum MembershipListKeys {
  NAME = 'name',
  FLAGS = 'flags',
}

export const NO_PARTY_FORM = {
  [MembershipListKeys.NAME]: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(65)]],
  [MembershipListKeys.FLAGS]: [[]],
};

export const createForm = formUtils.createForm(NO_PARTY_FORM);
export const setForm = formUtils.setForm(NO_PARTY_FORM);
